import type { PluginOptions } from 'vue-gtag'

const params: any = {}

const userJson = localStorage.getItem('user')
const currentUser = userJson === null ? null : JSON.parse(userJson)

if (currentUser) {
  params.user_id = currentUser.ID
  params.user_properties = {
    organization_id: currentUser.organizationID,
    role: currentUser.role,
  }
}

const gtagOptions: PluginOptions = {
  config: {
    id: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    params: params,
  },
}

export default gtagOptions
